import ScheduleReservation from './schedule_reservation';

export default ScheduleReservation;
